<template>
  <div class="stock-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="stock-container">
      <!-- Header Section -->
      <div class="stock-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-back-modern" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-boxes title-icon"></i>
              Gestão de Estoque
            </h1>
            <p class="page-subtitle">
              Sistema completo de controle e movimentação de estoque
            </p>
          </div>

          <div class="actions-section">
            <!-- Espaço para ações futuras -->
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="stock-content">
        <!-- Navigation Tabs -->
        <div class="tabs-section">
          <div class="tabs-container">
            <div class="tabs-wrapper">
              <div
                v-for="(tab, index) in tabs"
                :key="index"
                class="tab-item"
                :class="{ 'tab-active': currentTab === tab.step }"
                @click="handleTabClick(tab)"
              >
                <div class="tab-icon">
                  <i :class="getTabIcon(tab.step)"></i>
                </div>
                <span class="tab-label">{{ tab.title }}</span>
                <div v-if="currentTab === tab.step" class="tab-indicator"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tab Content -->
        <div class="tab-content-section">
          <div class="content-card">
            <transition name="fade" mode="out-in">
              <div :key="currentTab" class="tab-content">
                <!-- Stocks Tab -->
                <div v-if="currentTab === 'stocks'" class="content-wrapper">
                  <div class="content-header">
                    <h2 class="content-title">
                      <i class="fas fa-warehouse mr-2"></i>
                      Visualização de Estoques
                    </h2>
                    <p class="content-description">
                      Consulte e monitore os níveis de estoque em tempo real
                    </p>
                  </div>
                  <stocks />
                </div>

                <!-- Movement Tab -->
                <div v-if="currentTab === 'movement'" class="content-wrapper">
                  <div class="content-header">
                    <h2 class="content-title">
                      <i class="fas fa-exchange-alt mr-2"></i>
                      Movimentação de Estoque
                    </h2>
                    <p class="content-description">
                      Registre entradas, saídas, transferências e estornos
                    </p>
                  </div>
                  <movement />
                </div>

                <!-- History Tab -->
                <div v-if="currentTab === 'history'" class="content-wrapper">
                  <div class="content-header">
                    <h2 class="content-title">
                      <i class="fas fa-history mr-2"></i>
                      Histórico de Movimentações
                    </h2>
                    <p class="content-description">
                      Visualize o histórico completo de todas as movimentações
                    </p>
                  </div>
                  <history />
                </div>

                <!-- Groups Tab -->
                <div v-if="currentTab === 'groups'" class="content-wrapper">
                  <div class="content-header">
                    <h2 class="content-title">
                      <i class="fas fa-layer-group mr-2"></i>
                      Gestão de Grupos
                    </h2>
                    <p class="content-description">
                      Configure grupos e categorias para organização do estoque
                    </p>
                  </div>
                  <groups />
                </div>

                <!-- Items Tab -->
                <div v-if="currentTab === 'items'" class="content-wrapper">
                  <div class="content-header">
                    <h2 class="content-title">
                      <i class="fas fa-list mr-2"></i>
                      Gestão de Itens
                    </h2>
                    <p class="content-description">
                      Cadastre e gerencie medicamentos, produtos e lotes
                    </p>
                  </div>
                  <items />
                </div>

                <!-- Sale Tab -->
                <div v-if="currentTab === 'sale'" class="content-wrapper">
                  <div class="content-header">
                    <h2 class="content-title">
                      <i class="fas fa-shopping-cart mr-2"></i>
                      Vendas e Reajustes
                    </h2>
                    <p class="content-description">
                      Gerencie vendas e aplicação de reajustes
                    </p>
                  </div>
                  <sale />
                </div>

                <!-- Purchase Tab -->
                <div v-if="currentTab === 'purchase'" class="content-wrapper">
                  <div class="content-header">
                    <h2 class="content-title">
                      <i class="fas fa-shopping-bag mr-2"></i>
                      Compras
                    </h2>
                    <p class="content-description">
                      Registre e gerencie as compras de produtos e medicamentos
                    </p>
                  </div>
                  <purchase />
                </div>

                <!-- Readjustment Tab -->
                <div
                  v-if="currentTab === 'readjustment'"
                  class="content-wrapper"
                >
                  <div class="content-header">
                    <h2 class="content-title">
                      <i class="fas fa-calculator mr-2"></i>
                      Reajustes
                    </h2>
                    <p class="content-description">
                      Configure e aplique reajustes de preços
                    </p>
                  </div>
                  <readjustment />
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import Movement from "../templates/Stock/movement.vue";
import History from "../templates/Stock/history.vue";
import Stocks from "../templates/Stock/stocks.vue";
import Groups from "../templates/Stock/groups.vue";
import Items from "../templates/Stock/items.vue";
import Sale from "../templates/Stock/sale.vue";
import Purchase from "../templates/Stock/purchase.vue";
import Readjustment from "../templates/Stock/sale/readjustment.vue";

import permission from "../lib/permission";
import routes from "../routes";

export default {
  name: "NewStock",

  components: {
    NavBar,
    AuthBySessionExpired,
    Movement,
    History,
    Stocks,
    Groups,
    Items,
    Sale,
    Purchase,
    Readjustment,
  },

  data() {
    return {
      tabs: [],
      currentTab: "stocks",
    };
  },

  created() {
    this.initializeTabs();
    this.setInitialTab();
  },

  methods: {
    permission,

    handleToBack() {
      routes.go(-1);
    },

    initializeTabs() {
      this.tabs.push({ title: "ESTOQUES", step: "stocks", type: null });

      if (
        permission("write", "main_stock_input") ||
        permission("write", "main_stock_transfer") ||
        permission("write", "main_stock_output") ||
        permission("read", "main_stock_reversal")
      ) {
        this.tabs.push({
          title: "MOVIMENTAR",
          step: "movement",
          type: "entry",
        });
      }

      if (permission("read", "main_stock_history")) {
        this.tabs.push({ title: "HISTÓRICO", step: "history", type: "entry" });
      }

      if (permission("read", "stock")) {
        this.tabs.push({ title: "GRUPOS", step: "groups", type: "groups" });
      }

      if (permission("read", "product") || permission("read", "medicine")) {
        this.tabs.push({ title: "ITENS", step: "items", type: "medicines" });
      }

      if (permission("write", "main_stock_shopping")) {
        this.tabs.push({ title: "COMPRA", step: "purchase", type: null });
      }

      if (
        permission("read", "readjustment_type_of_hosting") ||
        permission("read", "readjustment_service")
      ) {
        this.tabs.push({ title: "REAJUSTE", step: "readjustment", type: null });
      }
    },

    setInitialTab() {
      // Define a aba inicial baseada na query da URL ou padrão
      const { menu } = this.$route.query;
      if (menu && this.tabs.find((tab) => tab.step === menu)) {
        this.currentTab = menu;
      } else {
        this.currentTab = this.tabs.length > 0 ? this.tabs[0].step : "stocks";
      }
    },

    handleTabClick(tab) {
      this.currentTab = tab.step;
      // Atualiza a URL com a aba selecionada
      this.$router.replace({
        query: {
          ...this.$route.query,
          menu: tab.step,
          tipo: tab.type,
        },
      });
    },

    getTabIcon(tabStep) {
      const icons = {
        stocks: "fas fa-warehouse",
        movement: "fas fa-exchange-alt",
        history: "fas fa-history",
        groups: "fas fa-layer-group",
        items: "fas fa-list",
        sale: "fas fa-shopping-cart",
        purchase: "fas fa-shopping-bag",
        readjustment: "fas fa-calculator",
      };
      return icons[tabStep] || "fas fa-folder";
    },
  },
};
</script>

<style scoped>
.stock-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.stock-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.stock-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.btn-back-modern {
  background: transparent !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-back-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* Content Section */
.stock-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
}

/* Tabs Section */
.tabs-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.tabs-container {
  padding: 8px;
}

.tabs-wrapper {
  display: flex;
  gap: 4px;
  overflow-x: auto;
  padding: 4px;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  min-width: 120px;
  text-align: center;
  background: transparent;
  color: #64748b;
  font-weight: 500;
}

.tab-item:hover {
  background: #f8fafc;
  color: #0f65b0;
  transform: translateY(-2px);
}

.tab-item.tab-active {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3);
}

.tab-icon {
  font-size: 18px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.tab-indicator {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 2px 2px 0 0;
}

/* Tab Content Section */
.tab-content-section {
  flex: 1;
}

.content-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  min-height: 600px;
}

.content-wrapper {
  padding: 32px;
}

.content-header {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #e5e7eb;
}

.content-title {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.content-title i {
  color: #0f65b0;
}

.content-description {
  color: #64748b;
  font-size: 16px;
  margin: 0;
  line-height: 1.5;
}

/* Tab Content */
.tab-content {
  min-height: 500px;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Scrollbar para tabs */
.tabs-wrapper::-webkit-scrollbar {
  height: 4px;
}

.tabs-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}

.tabs-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.tabs-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .stock-container {
    max-width: 1200px;
  }
}

@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }

  .tabs-wrapper {
    justify-content: center;
  }

  .tab-item {
    min-width: 100px;
    padding: 14px 16px;
  }

  .tab-label {
    font-size: 11px;
  }
}

@media (max-width: 768px) {
  .stock-container {
    padding: 0 16px;
  }

  .stock-header {
    padding: 16px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .content-wrapper {
    padding: 24px 20px;
  }

  .content-title {
    font-size: 20px;
  }

  .content-description {
    font-size: 14px;
  }

  .tabs-wrapper {
    flex-wrap: wrap;
    justify-content: center;
  }

  .tab-item {
    min-width: 90px;
    padding: 12px 14px;
  }

  .tab-icon {
    font-size: 16px;
  }

  .tab-label {
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .btn-back-modern {
    padding: 10px 16px !important;
    font-size: 14px !important;
  }

  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }

  .title-icon {
    font-size: 20px;
  }

  .content-wrapper {
    padding: 20px 16px;
  }

  .content-title {
    font-size: 18px;
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .tab-item {
    min-width: 80px;
    padding: 10px 12px;
    gap: 6px;
  }

  .tab-icon {
    font-size: 14px;
  }

  .tab-label {
    font-size: 9px;
  }
}

/* Estados especiais para diferentes tipos de conteúdo */
.content-wrapper >>> .v-data-table {
  background: transparent !important;
}

.content-wrapper >>> .v-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #e5e7eb !important;
}

.content-wrapper >>> .v-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

/* Loading states */
.content-card:empty::before {
  content: "Carregando...";
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #64748b;
  font-size: 16px;
}
</style>